import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import moment from 'moment';

//Components
import RelatorioCertificadoDestinacaoResiduos from './RelatorioCertificadoDestinacaoResiduos';
import MainCard from 'components/MainCard/MainCard';
import TextField from 'components/TextField/TextField';

//Helpers
import { PrintValidate } from 'helpers/ValidadorDeCampos';
import { objCampo } from 'helpers/ValidadorDeCampos';
import { showMessage } from 'helpers/message';
import { validarCampos } from 'helpers/ValidadorDeCampos';

//API
import relatorio_api from '../../../api/relatorio_api';
import gerador_api from '../../../api/gerador_api';

//Context
import { useAuth } from 'context/auth';


function initialStateFiltros() {
    const dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
    dataAtual.setMonth(dataAtual.getMonth() + 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");
    return {
        dataInicial,
        dataFinal, 
        locaisId: [],
        nomeRelatorio: "Certificado de Destinação de Resíduos"
    }
}
export default function CertificadoDestinacaoResiduos() {
  const { setLoading } = useAuth();

  //Estado de controle dos erros nos campos obrigatorios
  const [errors, setErrors] = useState({});
  //Guarda os filtros obrigatorios
  const campos = [
      objCampo({ name: "dataInicial", required: true }),
      objCampo({ name: "dataFinal", required: true }),
      objCampo({ name: "locaisId", required: true }),
  ]
  //Estado de controle dos valores dos filtros
  const [filtros, setFiltros] = useState(initialStateFiltros());

  const [listLocalidadesGerador, setListLocalidadesGerador] = useState([]);

  //Estado que guarda os dados do relatorio
  const [dadosRelatorio, setDadosRelatorio] = useState(null);

  //Variavel utilizada para navegação 
  const navigate = useNavigate();

  //Change para os campos data inicial, data final e status
  const onChangeFiltros = (e) => {
      const { name, value } = e.target;
      setFiltros({
          ...filtros,
          [name]: value
      })
  }

   //Change para o select de destinatario
    const onChangeLocais = (e, select) => {
        const { name } = select;
        const _filtros = {
            ...filtros,
            [name]: e,
        };

        const campo = campos.filter(value => value.name === name);
        const erroCampo = validarCampos(_filtros, campo);

        if (erroCampo[1].length > 0) 
            setErrors({ ...errors, ...erroCampo[0] });
        else {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        }

        setFiltros(_filtros);
    }
 
   //Função que puxa os dados do relatorio
   const carregarRelatorio = () => {
        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }

        setLoading(true);

        const _filtros = { ...filtros } 
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        _filtros.locaisId = _filtros.locaisId.map(({id}) => id);
        
        relatorio_api.RelatorioCertificadoDestinacaoResiduos(_filtros).then(response => {
            setDadosRelatorio(response.data);
        })
        .catch(e => showMessage("Aviso", e.message, "error", null))
        .finally(f => setLoading(false));
    }

    function loadLocalidadeGerador() {
        setLoading(true);
        gerador_api.GetListLocalidadesByGerador()
        .then(response => {
            response.data = response.data.map(value => {
                value.label = `${value.logradouro}, ${value.numero}, ${value.complemento}, ${value.bairro}`;
                value.value =  value.id.toString();
                return value;
            })
            setListLocalidadesGerador(response.data ?? []);
        })
        .catch(e => showMessage("Aviso", e.message, "error", null))
        .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadLocalidadeGerador();
    }, []);
  
    if (dadosRelatorio) {
        return <RelatorioCertificadoDestinacaoResiduos
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => setDadosRelatorio(null)}
            filtros={filtros}
        />
    }

  return (
     <MainCard btnVoltarInTop={() => navigate(-1)}>
        <h4>Certificado de Destinação de Resíduos</h4>
        <Row>
            <Col sm="12" md="6" lg="6">
                <TextField name="dataInicial" label={"* Data inicial"} type={"date"} value={filtros.dataInicial} onChange={onChangeFiltros} invalid={!!errors.dataInicial} />
                <PrintValidate field={"dataInicial"} errors={errors} />
            </Col>
            <Col sm="12" md="6" lg="6">
                <TextField name="dataFinal" label={"* Data final"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} invalid={!!errors.dataFinal} />
                <PrintValidate field={"dataFinal"} errors={errors} />
            </Col> 
            <Col md="12" lg="8">
                <TextField
                    label={"* Local de Coleta"}
                    type={"select"}
                    multiple
                    options={listLocalidadesGerador}
                    onChange={onChangeLocais}
                    value={filtros.locaisId}
                    name={"locaisId"}
                    invalid={errors.locaisId ? true : false}
                />
            </Col>
            <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRelatorio}>Gerar Relatório</Button>
            </Col>
        </Row>
        </MainCard>
  )
}
